export const scrollToTop = (smooth = true) => {
  return window.scrollTo({
    top: 0,
    left: 0,
    behavior: smooth ? 'smooth' : 'auto',
  });
};

export const scrollToRef = (ref, smooth = true) => {
  return ref && ref.current && ref.current.scrollIntoView({
    behavior: smooth ? 'smooth' : 'auto',
  });
};
